// material-ui
// import { Box, Grid } from "@mui/material";
import { Layout, Row, Col } from "antd";

// project import
// import AuthCard from "./AuthCard";
import Logo from "assets/images/vix-logo-h.png";
// import AuthFooter from "components/cards/AuthFooter";

// assets
// import AuthBackground from "assets/images/auth/AuthBackground";

// ==============================|| AUTHENTICATION - WRAPPER ||============================== //

const AuthWrapper = ({ children }) => (
  <Layout
    style={{
      minHeight: "100vh",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      backgroundImage: "linear-gradient(to right, #00204D, #06212C)",
      overflow: "hidden",
    }}
  >
    <Row justify="center" align="center" style={{ height: "100%", width: "100%" }}>
      <Row
        style={{
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
        justify="center"
        align="center"
      >
        <Col>
          <Row align={"center"} style={{ marginBottom: "15px" }}>
            <img alt="" src={Logo} height="90" />
          </Row>
          <Row>{children}</Row>
        </Col>
      </Row>
      {/* <AuthCard> */}
    </Row>
  </Layout>
);

export default AuthWrapper;
